export enum SplineCurveType {
	CATMULLROM = 'catmullrom',
	CENTRIPETAL = 'centripetal',
	CHORDAL = 'chordal',
}
export const SPLINE_CURVE_TYPES: SplineCurveType[] = [
	SplineCurveType.CATMULLROM,
	SplineCurveType.CENTRIPETAL,
	SplineCurveType.CHORDAL,
];
